module.exports = __webpack_public_path__ + "static/tr-section-5@2x-8e07ebaf763ab84cf389ed722ca3b58c.png";